var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _rect9, _rect10, _rect11, _path, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen12Light(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#eef3f3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#05070a",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#05070a",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#05070a",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#05070a",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#8a979d",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 160,
    height: 16,
    rx: 8,
    fill: "#0b1117",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 70,
    r: 18,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 112,
    width: 320,
    height: 160,
    rx: 20,
    fill: "#05070a",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 134,
    width: 80,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 152,
    width: 130,
    height: 30,
    rx: 8,
    fill: "#f6f6f2",
    opacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,236 L69,201 L98,209 L127,223 L156,232 L185,223 L214,236 L243,220 L272,209 L301,205",
    stroke: "#5ce1e6",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 292,
    width: 320,
    height: 72,
    rx: 18,
    fill: "#ffffff",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 308,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 314,
    width: 118,
    height: 9,
    rx: 4.5,
    fill: "#0b1117",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 332,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#8a979d",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 318,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#0b1117",
    opacity: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 376,
    width: 320,
    height: 72,
    rx: 18,
    fill: "#ffffff",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 392,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#dff7f8",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 398,
    width: 129,
    height: 9,
    rx: 4.5,
    fill: "#0b1117",
    opacity: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 416,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#8a979d",
    opacity: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 402,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#0b1117",
    opacity: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 460,
    width: 320,
    height: 72,
    rx: 18,
    fill: "#ffffff",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 476,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 482,
    width: 133,
    height: 9,
    rx: 4.5,
    fill: "#0b1117",
    opacity: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 500,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#8a979d",
    opacity: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 486,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#0b1117",
    opacity: 0.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 544,
    width: 320,
    height: 72,
    rx: 18,
    fill: "#ffffff",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 560,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#dff7f8",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 566,
    width: 135,
    height: 9,
    rx: 4.5,
    fill: "#0b1117",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 584,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#8a979d",
    opacity: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 570,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#0b1117",
    opacity: 0.8
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 696,
    width: 360,
    height: 84,
    rx: 0,
    fill: "#f1f5f5",
    opacity: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#b7c2c6",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#c9d2d5",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#b7c2c6",
    opacity: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#c9d2d5",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#b7c2c6",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#c9d2d5",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#b7c2c6",
    opacity: 1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#c9d2d5",
    opacity: 1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#05070a",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen12Light);
export default __webpack_public_path__ + "static/media/screen-12-light.81f4349cf8e9f516bb076bcc12cb4e36.svg";
export { ForwardRef as ReactComponent };